"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOutThunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var auth_1 = require("../apis/auth");
var session_1 = require("./session");
// Ends the session on the server too; awaited because clearing resets the API state and would abort the call.
// The attempt is bounded and the local session is always cleared afterwards, so a stalled connection can't keep the user signed in.
var signOutThunk = (0, toolkit_1.createAsyncThunk)("session/sign-out", function (_1, _a) { return __awaiter(void 0, [_1, _a], void 0, function (_, _b) {
    var REVOCATION_TIMEOUT_MS, signedOutSessionId, revocation, abortTimer, _c, isStillCurrentSession;
    var dispatch = _b.dispatch, getState = _b.getState;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                REVOCATION_TIMEOUT_MS = 5000;
                signedOutSessionId = getState().user.sessionId;
                revocation = dispatch(auth_1.authApi.endpoints.logout.initiate());
                abortTimer = setTimeout(function () { return revocation.abort(); }, REVOCATION_TIMEOUT_MS);
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, 4, 8]);
                return [4 /*yield*/, revocation.unwrap()];
            case 2:
                _d.sent();
                return [3 /*break*/, 8];
            case 3:
                _c = _d.sent();
                return [3 /*break*/, 8];
            case 4:
                clearTimeout(abortTimer);
                isStillCurrentSession = getState().user.sessionId === signedOutSessionId;
                if (!isStillCurrentSession) return [3 /*break*/, 6];
                return [4 /*yield*/, dispatch((0, session_1.clearSessionThunk)())];
            case 5:
                _d.sent();
                return [3 /*break*/, 7];
            case 6:
                revocation.reset();
                _d.label = 7;
            case 7: return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}); });
exports.signOutThunk = signOutThunk;
